<!-- IT设备采购申请表 -->
<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 提交		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		sendMessage,
		getFlowTemplate
	} from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'
	
	import {
			getDepartmentRelationByName,
			getDepartmentRelationById,
			getDepartmentInfo
		} from '@/api/department'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	const sendMessagetTemplate = {
	  title: null,
	  url: null,
	  toUser: [],
	  desc: null,
	  template: null,
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				sendMessageData: Object.assign({},sendMessagetTemplate),
				formLoading: false,
				listLoading: false,
				flowId:null
			}
		},
		created() {
			initWxConfig(this);
			stringUtils.setAddIsShow(false);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.flowId = this.$route.query.flowId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			
		},
		methods: { //方法
			
			clickChoose(dataVal, name) {
				var that=this;
				
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Value = depart.name;
						dataVal.Values=[[depart.id,depart.name]];
						// let depart = {
						// 	"id":"19203"
						// }
						getDepartmentInfo(depart.id).then(async res=>{
								var departFullName=res.Body.FullName; 
								var departName=departFullName.split("/");
								that.templateData.TemplateContent.Controls.forEach(async (item,index) => {
									
										if (item.Property.Title[0].Text == "经理/总监") {
											item.IsShow = false;
											item.Values = [];
											
											if (departFullName == "华西区/藤云/联动拓展部") {
												var insertDat = ["SC18004712", "张晓林"]
												item.Values.push(insertDat);
											} else {
												await getDepartmentRelationByName(departFullName, false).then(res => {
													if (res.Body != null) {
														for (var i = 0; i < res.Body.length; i++) {
															res.Body[i].Nodes.forEach((depData) => {
																if (depData.Items != null) {
																	depData.Items.forEach((userData) => {
																		if (userData.PositionName.indexOf("总监") > -1) {
																			if (item.Values == null || item.Values.length == 0) {
																				var insertDat = [userData.EmpNo, userData.EmpName]
																				item.Values.push(insertDat);
																				return;
																			}
																		}
																	})
																}
															});
															if (item.Values.length == 0) {
																res.Body[i].Nodes.forEach((depData) => {
																	if (depData.Items != null) {
																		depData.Items.forEach((userData) => {
																			if (userData.PositionName.indexOf("经理") > -1 && !(userData.PositionName.indexOf("总经理") >
																					-1) && !(userData.PositionName.indexOf("副总经理") >-1)) {
																				if (item.Values == null || item.Values.length == 0) {
																					var insertDat = [userData.EmpNo, userData.EmpName]
																					item.Values.push(insertDat);
																					return;
																				}
																			}
																		})
																	}
																});
															}
														}
													} else {
														item.Values = [
															["SC24000029", "钟志斌"]
														]
													}
													if (item.Values == null || item.Values.length == 0) {
														item.Values = [
															["SC24000029", "钟志斌"]
														]
													}
												});
											}
										}
										if (item.Property.Title[0].Text == "行政主任") {
											item.Values=[];
											item.Values = await that.getDepartmentRelation(depart.id, "行政主任");
											if (item.Values == null || item.Values.length <= 0) {
												//审批节点无人，跳过
												item.Values.push(that.$store.state.defaultMember);
											}
										}
										if (item.Property.Title[0].Text == "行政经理") {
											item.Values=[];
											item.Values = await that.getDepartmentRelation(depart.id, "行政经理");
											if (item.Values == null || item.Values.length <= 0) {
												//审批节点无人，跳过
												item.Values.push(that.$store.state.defaultMember);
											}
											item.IsShow = false;
										}
										if (item.Property.Title[0].Text == "逐级审批") {
											item.Values = [];
											item.IsShow = false;
											await getDepartmentRelationById(res.Body.DeptId).then(data => {
												if (data.Body != null && data.Body.length > 0) {
													for(var i = 0;i < data.Body[0].Nodes.length;i++){
														var depData = data.Body[0].Nodes[i];
														if(depData.DeptName == "非营业部"){
															break;
														}
														if (depData.Items != null) {
															depData.Items.sort(function(a,b){
																return a.JobLevel - b.JobLevel
															})
															depData.Items.forEach((userData) => {
																var insertDat = [userData.EmpNo, userData.EmpName]
																item.Values.push(insertDat);
															})
														}
													}
													
												} else {
													item.Values = [
														["SC24000029", "钟志斌"]
													]
												}
												if (item.Values == null || item.Values.length == 0) {
													item.Values = [
														["SC24000029", "钟志斌"]
													]
												}
											});
										}
										if (item.Property.Title[0].Text == "小战区区董") {
											item.Values=[];
											item.Values = await that.getDepartmentRelation(depart.id, "战区董事",true);
											if (item.Values == null || item.Values.length <= 0) {
												//审批节点无人，跳过
												item.Values.push(that.$store.state.defaultMember);
											}
										}
										if (item.Property.Title[0].Text == "大战区区董") {
											item.Values=[];
											item.Values = await that.getDepartmentRelation(depart.id, "董事总经理",true);
											if (item.Values == null || item.Values.length <= 0) {
												//审批节点无人，跳过
												// item.Values.push(["SC18006783", "王万华"]);
												//2021-9-3张彬离职临时调整
												item.Values.push(that.$store.state.defaultMember);
											}
										}
										if (item.Property.Title[0].Text == "总经理") {
											item.Values=[];
											await getDepartmentRelationByName(departFullName, false).then(res => {
												if (res.Body != null) {
													for (var i = 0; i < res.Body.length; i++) {
														res.Body[i].Nodes.forEach((depData) => {
															if (depData.Items != null) {
																depData.Items.forEach((userData) => {
																	if (userData.PositionName.indexOf("总经理") > -1&&userData.JobLevel>5) {
																		if (item.Values == null || item.Values.length == 0) {
																			var insertDat = [userData.EmpNo, userData.EmpName]
																			item.Values.push(insertDat);
																			return;
																		}
																	}
																})
															}
														});
													}
												} else {
													item.Values = [
														["SC24000029", "钟志斌"]
													]
												}
												if (item.Values == null || item.Values.length == 0) {
													item.Values = [
														["SC24000029", "钟志斌"]
													]
												}
											});
											if (item.Values == null || item.Values.length <= 0) {
												//审批节点无人，跳过
												item.Values.push(that.$store.state.defaultMember);
											}
										}
									if (item.Property.Title[0].Text == "申请人员部门") {
										
										if (departName.indexOf("住宅部") > -1) {
											item.Value = item.Config.Selector.Options
												.filter(item => {
													return item.Value[0].Text == "住宅部";
												})[0].Key;
										} else if (departName.indexOf("工商铺商业运营中心") > -1) {
											item.Value = item.Config.Selector.Options
												.filter(item => {
													return item.Value[0].Text == "工商铺商业运营中心";
												})[0].Key;
										} else if (departName.indexOf("房友圈") > -1 || departName.indexOf("藤云") > -1) {
											item.Value = item.Config.Selector.Options
												.filter(item => {
													return item.Value[0].Text == "房友圈";
												})[0].Key;
										} else if (departName.indexOf("二级市场营运中心") > -1||departName.indexOf("代理") > -1) {
											item.Value = item.Config.Selector.Options
												.filter(item => {
													return item.Value[0].Text == "二级市场营运中心/代理";
												})[0].Key;
										} else if (departName.indexOf("按揭金融服务中心") > -1) {
											item.Value = item.Config.Selector.Options
												.filter(item => {
													return item.Value[0].Text == "汇瀚";
												})[0].Key;
										} else if (departName.indexOf("原友信") > -1) {
											item.Value = item.Config.Selector.Options
												.filter(item => {
													return item.Value[0].Text == "原友信";
												})[0].Key;
										} else if (departName.indexOf("非营业部") > -1) {
											item.Value = item.Config.Selector.Options
												.filter(item => {
													return item.Value[0].Text == "非营业部";
												})[0].Key;
										} else if (departName.indexOf("华西区") > -1) {
											item.Value = item.Config.Selector.Options
												.filter(item => {
													return item.Value[0].Text == "华西区";
												})[0].Key;
										} 
										if (departName.indexOf("华西区信息中心") > -1) {
											item.Value = item.Config.Selector.Options
												.filter(item => {
													return item.Value[0].Text == "华西区信息中心";
												})[0].Key;
										}
									}
								if (item.Property.Title[0].Text == "请选择审批流程") {
									var departs = that.logInfo.fullName;
									var ApiDep = departFullName;
									item.Value = "";
									if (ApiDep.indexOf("华西区") > -1) {
										if (departs.indexOf("华西区信息中心") > -1) {
											item.Value = "option-1600689940132"
											item.IsShow = false;
										}else if (departs.indexOf("中国大陆华西区总裁办") > -1) {
											item.Value = "option-1600689940131"
											item.IsShow = false;
										} else {
											item.IsShow = true;
											item.Config.Selector.Options[0].Value[0].Text = "区域总裁助理聂丽娟审批";
											item.Config.Selector.Options[1].Value[0].Text = "华西区信息中心总经理审批";
										}
									}
									if (ApiDep.indexOf("按揭金融服务中心") > -1) {
										item.Value = "option-1600689940132"
										item.IsShow = false;
									}
									if (ApiDep.indexOf("华西区/原友信") > -1) {
										item.Value = "option-1600689940132"
										item.IsShow = false;
									}
									if (ApiDep.indexOf("华西区/四川中原物业顾问有限公司/非营业部") > -1) {
										item.Value = "option-1600689940132"
										item.IsShow = false;
									}
									
									if (departName.indexOf("住宅部") > -1 || that.logInfo.EmpNo == "SC15004802") {
										
										if (that.logInfo.EmpNo == "SC15004802") {
											item.Value = "option-1600689940131"
											item.IsShow = false;
										} else if (departs.indexOf("住宅行政支持组") > -1) {
											item.Value = "option-1600689940132"
											item.IsShow = false;
										} else {
											item.IsShow = true;
											item.Config.Selector.Options[0].Value[0].Text = "住宅部支援中心经理审批";
											item.Config.Selector.Options[1].Value[0].Text = "行政主任审批";
										}
									}
									if (ApiDep.indexOf("工商铺商业运营中心") > -1) {
										item.Value = "option-1600689940132"
										item.IsShow = false;
									}
									if (ApiDep.indexOf("华西区/房友圈") > -1) {
										if (departs.indexOf("华西区/房友圈") > -1) {
											item.Value = "option-1600689940131"
											item.IsShow = false;
										} 
										else if (departs.indexOf("华西区/房友圈/非营业部/职能中心/后勤房友圈") > -1) {
											item.Value = "option-1600689940132"
											item.IsShow = false;
										} else {
												item.IsShow = true;
												item.Config.Selector.Options[0].Value[0].Text = "房友圈部门经理/总监审批";
												item.Config.Selector.Options[1].Value[0].Text = "房友圈总经理助理刘晴审批";
										} 
									}
									
									if (ApiDep.indexOf("二级市场营运中心") > -1 || ApiDep.indexOf("代理") > -1) {
										if (departs.indexOf("华西区/代理/非营业部/二级市场支援中心") > -1) {
											item.Value = "option-1600689940132"
											item.IsShow = false;
										} else if (departs.indexOf("二级市场") > -1) {
											item.Value = "option-1600689940131"
											item.IsShow = false;
										} else {
											item.IsShow = true;
											item.Config.Selector.Options[0].Value[0].Text = "营运部总经理/副总经理审批";
											item.Config.Selector.Options[1].Value[0].Text = "总经理助理唐媛审批";
										}
									}
								}
								})
						});
				
					
					}
				})
			},

			getTemplate: async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				var that = this;
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					await that.getEmployeeRelation();
					await that.getFlowTemplateInfo();
					controls.TemplateContent.Controls.forEach(async (item,index) => {
						var departs = this.logInfo.fullName.split("/");
						if (item.Property.Control=="Table") {
							for(var i=0;i<item.Config.Table.Children.length;i++){
								var childItem=item.Config.Table.Children[i];
								if(childItem.Property.Title[0].Text == "预计金额"){
									childItem.Disable=true;
								}
							}
							
						}
						if (item.Property.Title[0].Text == "申请部门") {
							item.Values=[];
						}
						if (item.Property.Title[0].Text == "合计") {
							item.Disable=true;
						}
						
						if (item.Property.Title[0].Text == "行政主任") {
							item.Values = [];
							item.Values.push(this.$store.state.defaultMember);
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "行政经理") {
							item.Values = this.findEmpByPositionName(this.relationList, "行政经理");
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(this.$store.state.defaultMember);
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "小战区区董") {
							item.Values = this.findEmpByPositionName(this.relationList, "高级区域董事");
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(this.$store.state.defaultMember);
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "大战区区董") {
							item.Values = this.findEmpByPositionName(this.relationList, "高级大区董事");
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(this.$store.state.defaultMember);
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "经理/总监") {
							item.IsShow = false;
							item.Values = await this.getRelationList(this.relationList,7, "总监");
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								//小部门的经理
								item.Values = await this.getRelationList(this.relationList,7, "经理");
							}
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								//小部门的主任
								item.Values = await this.getRelationList(this.relationList,7, "主任");
							}
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(this.$store.state.defaultMember);
							}
						}
						if (item.Property.Title[0].Text == "逐级审批") {
							item.Values =[];
							item.IsShow = false;
							item.Values.push(this.$store.state.defaultMember);
						}
						if (item.Property.Title[0].Text == "总经理") {
							item.Values = await this.getRelationList(this.relationList,9, "总经理");
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(this.$store.state.defaultMember);
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "维修") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "请选择审批流程") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "申请人员部门") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "经理/总监") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "请选择审批流程") {
							item.IsShow = false;
							if (that.applyTemplateData != undefined) {
								var data = that.applyTemplateData.TemplateContent.Controls.filter(t => {
									return t.Property.Title[0].Text == item.Property.Title[0].Text
								});	
								item.Config.Selector.Options[0].Value[0].Text = data[0].Config.Selector.Options[0].Value[0].Text;
								item.Config.Selector.Options[1].Value[0].Text = data[0].Config.Selector.Options[1].Value[0].Text;
								item.IsShow = data[0].IsShow;
							}
						}
						
					});
					
					var controlsLength = controls.TemplateContent.Controls.length;
					for (var j = 0; j < controlsLength; j++) {
						var controlsData = controls.TemplateContent.Controls[j];
						var departs = that.logInfo.fullName.split("/");
						if (that.applyTemplateData != null) {
							var data = that.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == controlsData.Property.Title[0].Text
							});
							if (controlsData.Property.Title[0].Text == "物品信息") {
								controlsData.addIsShow = false;
								var i = 1;
								that.applyTemplateData.TemplateContent.Controls.forEach(async (applyData) => {
									if (applyData.Property.Title[0].Text.indexOf("物品信息") > -1) {
										if (applyData.Property.Title[0].Text != "物品信息") {
											
											var AddTable = JSON.stringify(controlsData);
											AddTable = JSON.parse(AddTable);
											AddTable.Property.Title[0].Text = AddTable.Property.Title[0].Text + i;
											
											// AddTable.Property.Id = "Table-" + this.guid();
											AddTable.addIsShow = false;
											// AddTable.Config.Table.Children.forEach(forDisable => {
											// 	forDisable.Disable = true;
											// });
											controls.TemplateContent.Controls.splice(j + i, 0, AddTable);
											i++;
										}
									}
								});
								controlsData.Config.Table.Children.forEach(childItem => {
									childItem.Disable = false;
								})
								break;
							}
						}
					}
					
					for (var j = 0; j < controlsLength; j++) {
						var controlsData = controls.TemplateContent.Controls[j];
						var departs = that.logInfo.fullName.split("/");
						if (that.applyTemplateData != null) {
							var data = that.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == controlsData.Property.Title[0].Text
							});
							if (controlsData.Property.Title[0].Text == "比价") {
								controlsData.addIsShow = false;
								console.log(controlsData)
								var i = 1;
								that.applyTemplateData.TemplateContent.Controls.forEach(async (applyData) => {
									if (applyData.Property.Title[0].Text.indexOf("比价") > -1) {
										if (applyData.Property.Title[0].Text != "比价") {
											
											var AddTable = JSON.stringify(controlsData);
											AddTable = JSON.parse(AddTable);
											AddTable.Property.Title[0].Text = AddTable.Property.Title[0].Text + i;
											
											// AddTable.Property.Id = "Table-" + this.guid();
											AddTable.addIsShow = false;
											// AddTable.Config.Table.Children.forEach(forDisable => {
											// 	forDisable.Disable = true;
											// });
											controls.TemplateContent.Controls.splice(j + i, 0, AddTable);
											i++;
										}
									}
								});
								controlsData.Config.Table.Children.forEach(childItem => {
									childItem.Disable = false;
								})
								break;
							}
						}
					}
					
					
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, null, this.flowId);
					if(this.flowId == null){
						var data = null;
						var indexs = 0;
						that.templateData.TemplateContent.Controls.forEach((item,index) =>{
							if (item.Property.Title[0].Text.indexOf("物品信息")>-1 ) {
								
								item.addIsShow = true;
							}
							
							if (item.Property.Title[0].Text == "比价") {
								item.addIsShow = false;
								item.Config.Table.Children.forEach(children =>{
									if(children.Property.Title[0].Text == "确认供应商"){
										children.Value = children.Config.Selector.Options[0].Key;
									}
								})
								data = JSON.parse(JSON.stringify(item));
								data.Config.Table.Children.forEach(children =>{
									if(children.Property.Title[0].Text == "确认供应商"){
										children.Value = children.Config.Selector.Options[1].Key;
									}
								})
								indexs = index;
							}
							
						})
						
						if(data!=null){
							data.Property.Title[0].Text = "比价2"
							that.templateData.TemplateContent.Controls.splice(indexs+1,0,JSON.parse(JSON.stringify(data)));
							data.Property.Title[0].Text = "比价1"
							that.templateData.TemplateContent.Controls.splice(indexs+1,0,JSON.parse(JSON.stringify(data)));
						}
					}
					
					this.listLoading = false;
				});
			},
			getEmployeeRelation: async function() {
				await getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {
				if(name=="类别"){
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "维修" && val.indexOf(item.Key) > -1;
						})[0];
					var control = controls.filter(item => item.Property.Title[0].Text == "维修")[0];
					if (option != null) {
						control.IsShow = true;
						control.Property.Require = 1;
					} else {
						control.IsShow = false;
						control.Property.Require = 0;
					}
				}
			},
			getFlowTemplateInfo: async function() {
				if (this.flowId == null || this.flowId == undefined || this.flowId.length <= 0) {
					return;
				}
				await getFlowTemplate(this.flowId).then(response => {
					this.applyTemplateData = response.Body;
				});
			},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				var isOk = 0;
				this.templateData.TemplateContent.Controls.forEach(item =>{
					if(item.Property.Title[0].Text.indexOf("比价")>-1){
						item.Config.Table.Children.forEach(children =>{
							if(children.Property.Title[0].Text.indexOf("确认供应商")==-1){
								if(children.Value == null ||children.Value ==""){
									children.Value = "空";
								}
							}
						})
						
					}
				})
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
				}
				//SC18002633 非维修
				//SC16006291 维修
				// if(this.templateData.TemplateContent.Controls.filter(item=>{return item.Property.Title[0].Text == "维修"})[0].IsShow==true){
				// 	this.sendMessageData.toUser=["SC16006291"];
				// }else{
				// 	this.sendMessageData.toUser=["SC18002633"];
				// }
				
				this.listLoading = true;
				isOk = 0;
				this.templateData.TemplateContent.Controls.forEach(item =>{
					if(item.Property.Title[0].Text.indexOf("比价")>-1){
						item.Config.Table.Children.forEach(children =>{
							if(children.Property.Title[0].Text.indexOf("确认供应商")>-1){
								children.Config.Selector.Options.forEach(option =>{
									if(option.Key == children.Value && option.Value[0].Text == '是'){
										if(isOk>1){
											return;
										}else{
											isOk++;
										}
									}
								})
							}
						})
						
					}
				})
				if(isOk==0){
					this.Message({
						message: '至少确认一组供应商为是',
						type: 'error',
						duration: 3 * 1000
					});
					this.listLoading = false;
					return;
				}
				if(isOk>1){
					this.Message({
						message: '只能确认一组供应商为是',
						type: 'error',
						duration: 3 * 1000
					});
					this.listLoading = false;
					return;
				}
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "人员"})[0];
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请部门"})[0];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请人："+control1.Value+" 申请部门："+control2.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请原因"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请原因："+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control4=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "合计"})[0]
				
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"总金额："+control4.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				this.templateData.SummaryList=SummaryList;
				
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					this.listLoading = false;
				});
			}
		}

	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
